import { InjectRepository } from "@nestjs/typeorm";
import { RootWiseCostReq,RootWiseCostModel,RootWiseCostActivateReq, RootwiseCostResponseModel, CostDto, CommonResponseModel, KmsDto, VehicleReqId, RouteCostIdreq } from "@project-management-system/shared-models";
import { RootWiseCostEntity } from "./root-wise-cost.entity";
import {  RootWiseCostRepository } from "./root-wise-cost.repo";
import { Injectable } from "@nestjs/common";
import { Not } from "typeorm";



@Injectable()
export class RootWiseCostService {
    constructor(
        private repo : RootWiseCostRepository
    ) { }

    async createRootWisecost(req: CostDto, isUpdate: boolean): Promise<RootwiseCostResponseModel> {
        // console.log(req, "ssssss");
        try {
            let rootCheck;
            if (!isUpdate) {
                rootCheck = await this.repo.findOne({ 
                    where: { 
                        routeType: req.routeType,
                        fromKmrange: req.fromKmrange,
                        type: req.type,
                        vehicleType:req.vehicleType
                    } 
                });
                if (rootCheck) {
                    return new RootwiseCostResponseModel(false, 0, 'Route Wise combination already exists');
                }
            } 
            // else {
            //     // For updates, check if the combination already exists excluding the current entity
            //     rootCheck = await this.repo.findOne({ 
            //         where: { 
            //             id:req.id
            //         } 
            //     });
            //     if (rootCheck) {
            //         return new RootwiseCostResponseModel(false, 0, 'Cost combination already exists');
            //     }
            // }
    
            // Assign common properties
            const entity = new RootWiseCostEntity();
            entity.routeType = req.routeType;
            entity.type= req.type;
            entity.fromKmrange = req.fromKmrange;
            entity.hrs = req.hrs;
            entity.toKmrange = req.toKmrange;
            entity.cost = req.cost;
            entity.plantId = req.plantId;
            entity.vehicleType=req.vehicleType;
            entity.criteria=req.criteria;
            entity.agreeSlab=req.agreeSlab;
            entity.perKmsRate=req.perKmsRate;
            entity.extraHrs=req.extraHrs;
            entity.localBattaBefAft=req.localBattaBefAft;
            entity.osbatta=req.osbatta
            entity.isActive = req.isActive;
            entity.versionFlag = req.versionFlag;
    
            if (isUpdate) {
                entity.id = req.id;
                entity.updatedUser = req.updatedUser; // Use updatedUser for updates
            } else {
                entity.createdUser = req.createdUser;
            }
    
            // Save the entity to the database
            const savedEntity = await this.repo.save(entity);
    
            // Convert saved entity to response model
            const convertedData = new RootWiseCostModel(
                savedEntity.id,
                savedEntity.routeType,
                savedEntity.fromKmrange,
                savedEntity.toKmrange,
                savedEntity.cost,
                savedEntity.vehicleType,
                savedEntity.criteria,
                savedEntity.agreeSlab,
                savedEntity.perKmsRate,
                savedEntity.extraHrs,
                savedEntity.localBattaBefAft,
                savedEntity.osbatta,
                savedEntity.isActive,
                savedEntity.versionFlag,
                savedEntity.plantId
            );
    
            // Return success response
            return new RootwiseCostResponseModel(true, 1, isUpdate ? 'Cost Updated successfully' : 'Cost Saved successfully', [convertedData]);
    
        } catch (err) {
            // If any error occurs, throw it
            throw err;
        }
    }
    
    

    async getAllRootwiseCostInfo(req:RouteCostIdreq,):Promise<RootwiseCostResponseModel>{
        try{

            let query = this.repo.createQueryBuilder('rootwiseCost')
            .leftJoinAndSelect('rootwiseCost.plantsInfo', 'plantsInfo') 
            .orderBy('rootwiseCost.type', 'ASC')
            .addOrderBy('rootwiseCost.vehicleType', 'ASC');

            if (req.routeCostId != undefined) {
                query.andWhere('rootwiseCost.id = :routeCostId', { routeCostId: req.routeCostId });
            }
            if (req && req.plant) {
                query.andWhere('plantsInfo.plant_name = :plantName', { plantName: req.plant });
            }
            let data = await query.getMany();
            // console.log(data,'dataaaaaaaaaaaaaaaaa')
            if(data.length > 0){
                // for(const rec of data){
                //     info.push(new RootWiseCostModel(rec.id,rec.routeType,rec.fromKmrange,rec.toKmrange,rec.cost,rec.vehicleType,rec.criteria,rec.agreeSlab,rec.perKmsRate,rec.extraHrs,rec.localBattaBefAft,rec.osbatta,rec.isActive,rec.versionFlag))
                // }
                return new RootwiseCostResponseModel(true,1,'Data retrieved',data)
            } else{
                return new RootwiseCostResponseModel(false,0,'No data found',[])
            }

        } catch(err){
            throw err
        }
   }

   async activateOrDeactivateRootwiseCost(req: RootWiseCostActivateReq): Promise<RootwiseCostResponseModel> {
    try {
        const RootwiseCostExists = await this.repo.findOne({where:{id:req.id}});
        if (RootwiseCostExists) {
            if (req.versionFlag !== RootwiseCostExists.versionFlag) {
                return new RootwiseCostResponseModel(false,10113, 'Someone updated the current  information.Refresh and try again');
            } else {

                const RootwiseCostStatus = await this.repo.update(
                    { id: req.id },
                    { isActive: req.isActive, updatedUser: req.updatedUser });

                if (RootwiseCostExists.isActive) {
                    if (RootwiseCostStatus.affected) {
                        const busAreaResponse: RootwiseCostResponseModel = new RootwiseCostResponseModel(true, 10115, 'RootwiseCost is Deactivated successfully');
                        return busAreaResponse;
                    } else {
                        return new RootwiseCostResponseModel(false,10111, 'RootwiseCost is already Deactivated');
                    }
                } else {
                    if (RootwiseCostStatus.affected) {
                        const busAreaResponse: RootwiseCostResponseModel = new RootwiseCostResponseModel(true, 10114, 'RootwiseCost is Activated successfully');
                        return busAreaResponse;
                    } else {
                        return new RootwiseCostResponseModel(false,10112, 'RootwiseCost is already Activated');
                    }
                }
                // }
                }
        } else {
            return new RootwiseCostResponseModel(false,99998, 'No Records Found');
        }
        } catch (err) {
            return err;
        }
    }

    
    async getAllActiveRootWiseCostInfo():Promise<RootwiseCostResponseModel>{
        try{
            const data = await this.repo.find({where:{isActive:true}})
            let info = []
            if(data.length > 0){
                for(const rec of data){
                    info.push(new RootWiseCostModel(rec.id,rec.routeType,rec.fromKmrange,rec.toKmrange,rec.cost,rec.vehicleType,rec.criteria,rec.agreeSlab,rec.perKmsRate,rec.extraHrs,rec.localBattaBefAft,rec.osbatta,rec.isActive,rec.versionFlag,rec.plantId))
                }
                return new RootwiseCostResponseModel(true,1,'Data retrieved',info)
            } else{
                return new RootwiseCostResponseModel(false,0,'No data found',info)
            }

        } catch(err){
            throw err
        }
   }

   async getCost(req:KmsDto):Promise<CommonResponseModel>{
    try{
        if(req.type === "IN HOUSE"){
            req.type = "INHOUSE";
        }
        else{
            req.type = "VENDOR";
        }
        let condition = "";
        if(req.vendorId  != null){
            condition = " and vendor_id = "+req.vendorId;
        }
        const query = 'SELECT id AS slabId,agreed_slab AS aggredSlab,from_km_range AS nearest_kms,per_kms_rate AS perKms,IF('+req.kms+' <= from_km_range, agreed_slab, (agreed_slab + ('+req.kms+' - from_km_range) * per_kms_rate)) AS slab FROM root_wise_cost WHERE vehicle_type = "'+req.vehicleType+'" and type = "'+req.type+'" and from_km_range = IF('+req.kms+'<="40",40,80) '+condition+' ORDER BY cost ASC LIMIT 1'


        // let query = "SELECT agreed_slab AS aggredSlab,nearest_kms,per_kms_rate AS perKms,IF("+req.kms+" <= from_km_range, agreed_slab, (agreed_slab + ("+req.kms+" - from_km_range) * per_kms_rate)) AS slab FROM root_wise_cost JOIN (SELECT IF("+req.kms+" >= '80', MAX(from_km_range), MIN(from_km_range)) AS nearest_kms FROM root_wise_cost WHERE vehicle_type = '"+req.vehicleType+"' AND TYPE = '"+req.type+"'"+condition+") AS km_range ON root_wise_cost.from_km_range = km_range.nearest_kms WHERE vehicle_type = '"+req.vehicleType+"' and type = '"+req.type+"'"+condition+" ORDER BY cost ASC LIMIT 1"
        const result =await this.repo.query(query)
        // console.log(result);
        if( result.length > 0){
            return new CommonResponseModel(true,1,'Data retrieved',result[0])
        } else{
            return new CommonResponseModel(false,0,'No Slab found',)
        }

    } catch(err){
        throw err
    }
}

async getRouteById(req:VehicleReqId): Promise<CommonResponseModel> {
    let query = await this.repo.findOne({where:{id:req.reqId}})
    if(query.id >0){
        return new CommonResponseModel(true,1,"data retrived", query);
    }
    else{
        return new CommonResponseModel(false,0,"no data found",);
    }
}

async getExactSlabCost(req:KmsDto):Promise<CommonResponseModel>{
    try{
        // console.log(req); 
        if(req.type === "INHOUSE"){
            req.type = "INHOUSE";
        }
        else{
            req.type = "VENDOR";
        }
        let condition = "";
        if(req.vendorId  != null){
            condition = " and vendor_id = "+req.vendorId;
        }
        let query;
        if(req.routeType === "L"){
            query = 'SELECT os_batta AS osbatta, local_Batta_bef_aft AS localBattaBefAft, from_km_range AS fromKmrange,hrs AS hrs,id AS slabId,agreed_slab AS aggredSlab,from_km_range AS nearest_kms,per_kms_rate AS perKms, agreed_slab AS slab FROM root_wise_cost WHERE vehicle_type = "'+req.vehicleType+'" and type = "'+req.type+'" and from_km_range = IF('+req.extraHrs+'<="5"and '+req.kms+'<= 40,40,IF('+req.extraHrs+'>"5"and '+req.kms+'> 40,80,80)) '+condition+' ORDER BY cost ASC LIMIT 1'
        }
        else if(req.routeType === "O/S") 
        {
            query = 'SELECT os_batta AS osbatta, local_Batta_bef_aft AS localBattaBefAft, from_km_range AS fromKmrange,hrs AS hrs,id AS slabId,agreed_slab AS aggredSlab,from_km_range AS nearest_kms,per_kms_rate AS perKms, agreed_slab AS slab FROM root_wise_cost WHERE vehicle_type = "'+req.vehicleType+'" and type = "'+req.type+'" and from_km_range = "80" '+condition+' ORDER BY cost ASC LIMIT 1'
        }
        const result =await this.repo.query(query)
        console.log(result);
        if( result.length > 0){
            return new CommonResponseModel(true,1,'Data retrieved',result[0])
        } else{
            return new CommonResponseModel(false,0,'No Slab found',)
        }

    } catch(err){
        throw err
    }
}

async vehcileTypeFromrootwisecost():Promise<CommonResponseModel>{
    try{
        const query='select id,vehicle_type as vehicleType from root_wise_cost group by vehicle_type'
        const res = await this.repo.query(query)
        if(res.length >0){
            return new CommonResponseModel(true,1,'Data Retrived Sucessfully',res)
        }else{
            return new CommonResponseModel(false,0,'No Data Found',[])
        }


    }catch(err){
        throw err
    }
}

}